import React, { useEffect, useState } from 'react';
// import Select from 'react-select';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
// import { customStyle } from 'helper';
import PropTypes from 'prop-types';
import NumberFormat from 'react-number-format';
import _ from 'lodash';
import * as actions from '../../../action';
// import * as c from '../../../constant';
function LandStripFrontAgesComponent({ value, onChange, type, formData }) {
  const [items, setItem] = useState({
    item: [],
  });

  useEffect(() => {
    setItem({
      item: value || [],
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  const updateProps = (newItem) => {
    onChange(_.get(newItem, 'item'));
  };

  const handleAddItem = () => {
    if (type === 'Stripage') {
      setItem({
        item: (items.item || []).concat([
          {
            localId: (_.get(items, `item.${items.item.length - 1}.localId`) || 0) + 1,
            unit_value:
              +_.get(items, `item.${items.item.length - 1}.unit_value`) -
              +_.get(items, `item.${items.item.length - 1}.unit_value`) * +0.2,
            type,
          },
        ]),
      });
    }
    if (type === 'Frontage') {
      setItem({
        item: (items.item || []).concat([
          {
            localId: (_.get(items, `item.${items.item.length - 1}.localId`) || 0) + 1,
            unit_value:
              +_.get(items, `item.${items.item.length - 1}.unit_value`) / 2,
            type,
          },
        ]),
      });
    }
  };

  const handleRemoveItem = (item) => () => {
    const newItem = {
      item: (items.item || []).filter((x) => x.localId !== item.localId),
    };
    setItem(newItem);
    updateProps(newItem);
  };

  const onBlurDecimal =
    (item, key) =>
    ({ target }) => {
      const newItem = {
        item: (items.item || []).map((x) =>
          x.localId === item.localId
            ? { ...x, [key]: target.value ? target.value : '' }
            : x
        ),
      };
      setItem(newItem);
      updateProps(newItem);
    };

  const onChangeDecimal = (item, key, amount) => {
    const newItem = {
      item: (items.item || []).map((x) =>
        x.localId === item.localId
          ? {
              ...x,
              [key]: parseFloat(amount) ? parseFloat(amount) : 0,
              base_market_value:
                parseFloat(amount) * parseFloat(item.unit_value),
            }
          : x
      ),
    };
    setItem(newItem);
    updateProps(newItem);
  };

  return (
    <>
      <div className="col-12 form-group">
        <table
          width="100%"
          className="strip-table table table-sm table-bordered"
        >
          <thead className="table-header">
            <tr>
              <td width="150">
                <span className="font-weight-bold">Area</span>
              </td>
              <td width="100">
                <span className="font-weight-bold">Unit Value</span>
              </td>
              <td width="150">
                <span className="font-weight-bold">Base Market Value</span>
              </td>
              <td width="50">
                <span className="font-weight-bold">Action</span>
              </td>
            </tr>
          </thead>
          <tbody className="p-3">
            {(type === 'Frontage' ? [items.item[0]] : items.item || []).map(
              (item, i) => (
                <tr key={+item?.localId}>
                  <td width="150">
                    <NumberFormat
                      name="area"
                      id="area"
                      placeholder="0"
                      className="form-control"
                      onValueChange={(values) => {
                        const { floatValue } = values;
                        onChangeDecimal(item, 'area', floatValue);
                      }}
                      onBlur={onBlurDecimal}
                      isNumericString
                      thousandSeparator
                      allowNegative={false}
                      allowLeadingZeros
                      displayType="input"
                      prefix=""
                      value={_.get(item, 'area') || ''}
                    />
                  </td>
                  <td width="100">
                    <NumberFormat
                      name="unit_value"
                      id="unit_value"
                      placeholder="0"
                      className="form-control"
                      isNumericString
                      thousandSeparator
                      allowNegative={false}
                      allowLeadingZeros
                      displayType="input"
                      prefix=""
                      value={_.get(item, 'unit_value', '') || ''}
                      disabled
                    />
                  </td>
                  <td width="150">
                    <NumberFormat
                      name="base_market_value"
                      id="base_market_value"
                      placeholder="0"
                      className="form-control"
                      isNumericString
                      thousandSeparator
                      allowNegative={false}
                      allowLeadingZeros
                      displayType="input"
                      prefix=""
                      value={_.get(item, 'base_market_value', '') || ''}
                      disabled
                    />
                  </td>
                  {i !== 0 && (
                    <td width="50">
                      <button
                        type="button"
                        className="btn-blank"
                        onClick={handleRemoveItem(item)}
                      >
                        <i className="far fa-trash-alt icon-delete" />
                      </button>
                    </td>
                  )}
                </tr>
              )
            )}
          </tbody>
        </table>
        {type === 'Frontage' && items.item.slice(1).length > 0 && (
          <table
            width="100%"
            className="strip-table table table-sm table-bordered"
          >
            <thead className="table-header">
              <tr>
                <td width="150">
                  <span className="font-weight-bold">Length</span>
                </td>
                <td width="100">
                  <span className="font-weight-bold">Unit Value</span>
                </td>
                <td width="150">
                  <span className="font-weight-bold">Base Market Value</span>
                </td>
                <td width="50">
                  <span className="font-weight-bold">Action</span>
                </td>
              </tr>
            </thead>
            <tbody className="p-3">
              {(items.item.slice(1) || []).map((item, i) => (
                <tr key={+item?.localId}>
                  <td width="150">
                    <NumberFormat
                      name="area"
                      id="area"
                      placeholder="0"
                      className="form-control"
                      onValueChange={(values) => {
                        const { floatValue } = values;
                        onChangeDecimal(item, 'area', floatValue);
                      }}
                      onBlur={onBlurDecimal}
                      isNumericString
                      thousandSeparator
                      allowNegative={false}
                      allowLeadingZeros
                      displayType="input"
                      prefix=""
                      value={_.get(item, 'area') || ''}
                    />
                  </td>
                  <td width="100">
                    <NumberFormat
                      name="unit_value"
                      id="unit_value"
                      placeholder="0"
                      className="form-control"
                      isNumericString
                      thousandSeparator
                      allowNegative={false}
                      allowLeadingZeros
                      displayType="input"
                      prefix=""
                      value={_.get(item, 'unit_value', '') || ''}
                      disabled
                    />
                  </td>
                  <td width="150">
                    <NumberFormat
                      name="base_market_value"
                      id="base_market_value"
                      placeholder="0"
                      className="form-control"
                      isNumericString
                      thousandSeparator
                      allowNegative={false}
                      allowLeadingZeros
                      displayType="input"
                      prefix=""
                      value={_.get(item, 'base_market_value', '') || ''}
                      disabled
                    />
                  </td>
                  <td width="50">
                    <button
                      type="button"
                      className="btn-blank"
                      onClick={handleRemoveItem(item)}
                    >
                      <i className="far fa-trash-alt icon-delete" />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
        {(items.item || []).length > 0 && formData.type !== '' && (
          <div className="mt-2">
            <button
              type="button"
              onClick={handleAddItem}
              className="btn button-add-another"
            >
              <i className="fas fa-plus" /> &nbsp; Add {formData.type}
            </button>
          </div>
        )}
      </div>
    </>
  );
}

LandStripFrontAgesComponent.defaultProps = {
  type: '',
  // unitValue: 0,
  formData: {},
};

LandStripFrontAgesComponent.propTypes = {
  onChange: PropTypes.instanceOf(Function).isRequired,
  value: PropTypes.instanceOf(Array).isRequired,
  // unitValue: PropTypes.number,
  type: PropTypes.string,
  formData: PropTypes.instanceOf(Object),
  // setFormData: PropTypes.instanceOf(Function).isRequired,
  // actualUseList: PropTypes.instanceOf(Array).isRequired,
};

const mapStateToProps = () => ({
  // actualUseList: _.get(api, `${c.GET_ACTUAL_USES}.list`) || [],
});

const enhance = _.flowRight([
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(LandStripFrontAgesComponent);
